import {
  TextField,
  FreeText,
  Signature,
  Selection,
  Image
} from '@abbott-components/icons';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ControlKind from '../Shared/controlKind';
import NumbersIcon from '@mui/icons-material/Numbers';
import CalculateIcon from '@mui/icons-material/Calculate';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { Document as DocumentIcon } from '@abbott-components/icons';

export default [
  {
    type: ControlKind.TEXT,
    icon: <TextField />
  },
  {
    type: ControlKind.NUMERIC,
    icon: <NumbersIcon />
  },
  {
    type: ControlKind.READONLY_TEXT,
    icon: <FreeText />
  },
  {
    type: ControlKind.DATE,
    icon: <CalendarMonthIcon />
  },
  {
    type: ControlKind.SIGNATURE,
    icon: <Signature />
  },
  {
    type: ControlKind.SELECT,
    icon: <Selection />
  },
  {
    type: ControlKind.IMAGE,
    icon: <Image />
  },
  {
    type: ControlKind.CALCULATED_VALUE,
    icon: <CalculateIcon />
  },
  {
    type: ControlKind.ATTACHMENT,
    icon: <AttachFileIcon />
  },
  {
    type: ControlKind.TIME,
    icon: <ScheduleIcon />
  },
  {
    type: ControlKind.PAGE,
    icon: <DocumentIcon />
  }
];
